(() => {
  if (customElements.get('byzayn-brand-mark')) return;
  const sessionKey = 'byzayn.emblem-intro.v2';
  let playedThisDocument = false;
  const isPreview = () => Boolean(window.Shopify?.designMode) ||
    (window.Shopify?.theme?.role === 'unpublished' &&
      new URLSearchParams(window.location.search).has('byzayn_motion_preview'));
  customElements.define('byzayn-brand-mark', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.animations = [];
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.icon = this.querySelector('.byzayn-brand-mark__icon');
      this.wordmark = this.querySelector('.byzayn-brand-mark__wordmark');
      this.reveal = this.querySelector('.byzayn-brand-mark__reveal');
      if (this.motionPreference.matches || !this.icon || !this.wordmark ||
          !this.reveal || typeof this.icon.animate !== 'function') {
        this.restoreStatic();
        return;
      }
      this.onMotionChange = () => {
        if (this.motionPreference.matches) this.restoreStatic();
      };
      this.motionPreference.addEventListener('change', this.onMotionChange);
      this.onVisible = () => {
        if (document.visibilityState !== 'visible') return;
        document.removeEventListener('visibilitychange', this.onVisible);
        this.playIntro();
      };
      const image = new Image();
      image.src = this.wordmark.querySelector('image').getAttribute('href');
      Promise.all([
        typeof this.icon.decode === 'function' ? this.icon.decode() : Promise.resolve(),
        typeof image.decode === 'function' ? image.decode() : Promise.resolve()
      ]).catch(() => {}).then(() => {
        if (!this.isConnected || this.motionPreference.matches) {
          this.restoreStatic();
          return;
        }
        if (document.visibilityState === 'hidden') {
          this.restoreStatic();
          document.addEventListener('visibilitychange', this.onVisible);
        } else {
          this.playIntro();
        }
      });
    }
    restoreStatic() {
      window.clearTimeout(this.logoIntroWatchdog);
      this.removeAttribute('data-intro-pending');
      this.animations?.forEach(animation => animation.cancel());
    }
    playIntro() {
      if (!this.isConnected || this.motionPreference.matches || this.played ||
          this.dataset.introExpired === 'true') {
        this.restoreStatic();
        return;
      }
      this.played = true;
      if (!isPreview()) {
        try {
          if (playedThisDocument || window.sessionStorage.getItem(sessionKey)) {
            this.restoreStatic();
            return;
          }
          window.sessionStorage.setItem(sessionKey, '1');
        } catch {}
        if (playedThisDocument) {
          this.restoreStatic();
          return;
        }
        playedThisDocument = true;
      }
      window.clearTimeout(this.logoIntroWatchdog);
      const offset = getComputedStyle(this).getPropertyValue('--bz-emblem-offset').trim() || '99px';
      this.animations = [
        this.icon.animate([
          { offset: 0, transform: 'translateX(' + offset + ') rotate(0deg) scale(1.05)', easing: 'cubic-bezier(.12,.68,.24,1)' },
          { offset: .42, transform: 'translateX(' + offset + ') rotate(720deg) scale(1.05)', easing: 'ease-in-out' },
          { offset: .49, transform: 'translateX(' + offset + ') rotate(727deg) scale(1.05)', easing: 'ease-in-out' },
          { offset: .55, transform: 'translateX(' + offset + ') rotate(720deg) scale(1.05)', easing: 'cubic-bezier(.22,1,.36,1)' },
          { offset: .79, transform: 'translateX(0px) rotate(720deg) scale(1.05)', easing: 'cubic-bezier(.22,1,.36,1)' },
          { offset: 1, transform: 'translateX(0px) rotate(720deg) scale(.82)' }
        ], { duration: 2100, iterations: 1, fill: 'both' }),
        this.reveal.animate([
          { transform: 'scaleX(0)' },
          { transform: 'scaleX(1)' }
        ], { duration: 795, delay: 1155, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' }),
        this.wordmark.animate([
          { opacity: 0, transform: 'translateX(-8px)' },
          { opacity: 1, transform: 'translateX(0px)' }
        ], { duration: 650, delay: 1155, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' })
      ];
      this.removeAttribute('data-intro-pending');
      Promise.all(this.animations.map(animation => animation.finished))
        .then(() => this.restoreStatic()).catch(() => {});
    }
    disconnectedCallback() {
      this.restoreStatic();
      if (this.onMotionChange) {
        this.motionPreference?.removeEventListener('change', this.onMotionChange);
      }
      if (this.onVisible) document.removeEventListener('visibilitychange', this.onVisible);
    }
  });
})();
